import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Button, Image, Container } from "react-bootstrap";
import { Document } from "react-pdf";
import { Page } from "react-pdf";

import ExplanationOfBenefits from "../ExplanationOfBenefits/ExplanationOfBenefits";
import CustomButton from "../../../components/UI/Button/Button";
import Modal from "../../../components/UI/Modal/Modal";
import BrowseImages from "./BrowsePatientsResponsibility/BrowsePatientsResponsibility";
import * as patientsResponsibilityActions from "../../../store/actions/index.js";
import ViewPatientsResponsibility from "./ViewPatientsResponsibility/ViewPatientsResponsibility";

import classes from "./PatientsResponsibility.module.css";
// import { useTranslation,withTranslation } from 'react-i18next';

import dollar from "../../../assets/images/icon-dollar-small.svg";
import dynamicMessages from "../../../dynamicMessages";
interface IParentProps {
  goBackHandler: () => void;
}
interface IStateFromProps {
  patientsResponsibilityBills: File[];
  documentTypes: {
    id: string;
    type: string;
    editable: boolean;
    order: number;
  }[];
  config_values: {
    customValue: string | null;
    defaultValue: string;
    element: string;
    elementType: string;
    id: string;
    targetPageTitle: string;
  }[];
  balanceBillView: string;
  // t:any;
  t:any;
}
interface IDispatchFromProps {
  onRemoveFiles: (fileArray: File[]) => void;
  onSetBalanceBillViewState: (balanceBillView) => void;
}
type Props = IStateFromProps & IDispatchFromProps & IParentProps;
class PatientsResponsibility extends Component<Props> {
  state = {
    patientsResponsibilityUploaded: false,
    patientsResponsibilityBillsUploading: false,
    patientsResponsibilityBillsAvailable: true,
    viewingBills: false,
    viewBillNumber: 0,
    explanationOfBenefits: false,
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.patientsResponsibilityBills.length !==
      prevProps.patientsResponsibilityBills.length
    )
      if (this.props.patientsResponsibilityBills.length > 0) {
        this.setState({ patientsResponsibilityUploaded: true });
      } else {
        this.setState({ patientsResponsibilityUploaded: false });
      }

    if (prevProps.balanceBillView !== this.props.balanceBillView) {
      console.log("inside if of getStarted");
      if (this.props.balanceBillView === "explanationOfBenefits") {
        this.setState({ explanationOfBenefits: true });
      } else if (this.props.balanceBillView === "notExplanationOfBenefits" || this.props.balanceBillView === "") {
        this.setState({ explanationOfBenefits: false });
      }
    }
  }
  // componentWillUnmount() {
  //   this.props.onRemoveFiles([]);
  // }
  uploadPatientsResponsibilityHandler = () => {
    this.setState({ patientsResponsibilityBillsUploading: true });
  };
  patientsResponsibilityUploadedHandler = () => {
    this.setState({ patientsResponsibilityBillsUploading: false });
  };

  viewingBillsHandler = (index: number) => {
    console.log(index);
    this.setState({ viewBillNumber: index });
    this.setState({ viewingBills: true });
  };
  closeViewingBillsHandler = () => {
    this.setState({ viewingBills: false });
  };

  onChangeFavorite = (event) => {
    console.log(event.target.checked, event.target.name);
    if (event.target.checked) {
      this.setState({ patientsResponsibilityBillsAvailable: false });
    } else if (!event.target.checked) {
      this.setState({ patientsResponsibilityBillsAvailable: true });
    }
  };
  deleteHandler = (index: number) => {
    var array = [...this.props.patientsResponsibilityBills];
    if (index !== -1) {
      array.splice(index, 1);
      this.props.onRemoveFiles(array);
    }
  };
  explanationOfBenefitsHandler = () => {
    this.setState({ explanationOfBenefits: true });
  };

  explanationOfBenefitsBackHandler = () => {
    this.setState({ explanationOfBenefits: false });
  };
  goBackHandler = () => {
    this.props.onRemoveFiles([]);
    this.props.goBackHandler();
  };

  getConvertedQuestion=()=>{
    let data = this.props.config_values
                          .find(
                            (ele) =>
                              ele.targetPageTitle.toLowerCase() ===
                                "Patient Responsibility Receipt".toLowerCase() &&
                              ele.element.toLowerCase() ===
                                "header".toLowerCase()
                          );
         let item =  data?data.defaultValue.split("\n")[0]:null;
         return dynamicMessages(item)?this.props.t(dynamicMessages(item)):item


  }
  render() {
    const {t} = this.props;
    // const { goBackHandler } = { ...this.props };
    const nextBtnStyle = {
      minWidth: "150px",
    };

    const modalViewBillStyle = {
      width: "700px",
      left: "calc(50% - 350px)",
      top: "15%",
      position: "absolute",
    };
    const patientsResponsibilityBillsUpload = (
      <Modal
        show={this.state.patientsResponsibilityBillsUploading}
        childComp={
          <BrowseImages 
            modalClosed={this.patientsResponsibilityUploadedHandler}
          />
        }
        style={{}}
      />
    );

    let viewBills: any;
    if (this.state.viewingBills) {
      viewBills = (
        <Modal
          show={this.state.viewingBills}
          childComp={
            <ViewPatientsResponsibility
              viewBillNumber={this.state.viewBillNumber}
              closeViewing={this.closeViewingBillsHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }

    const patientsResponsibilityUploadedCount = (
      <div className="selectedFiles">
        <div>
          <span className="filesCount">
            {this.props.patientsResponsibilityBills
              ? this.props.patientsResponsibilityBills.length
              : "0"}
          </span>
          {t('uploadBill.billsUploaded')}
        </div>
      </div>
    );

    /* banner */
    const patientsResponsibilityBanner = (
      <div className="uploadList">
        {/* <strong> */}
        {this.props.config_values &&
        this.props.config_values.find(
          (ele) =>
            ele.targetPageTitle.toLowerCase() ===
              "Patient Responsibility Receipt".toLowerCase() &&
            ele.element.toLowerCase() ===
              "Patient Responsibility is Critical".toLowerCase()
        )
          ? this.props.config_values.find(
              (ele) =>
                ele.targetPageTitle.toLowerCase() ===
                  "Patient Responsibility Receipt".toLowerCase() &&
                ele.element.toLowerCase() ===
                  "Patient Responsibility is Critical".toLowerCase()
            )?.customValue
            ? this.props.config_values
                .find(
                  (ele) =>
                    ele.targetPageTitle.toLowerCase() ===
                      "Patient Responsibility Receipt".toLowerCase() &&
                    ele.element.toLowerCase() ===
                      "Patient Responsibility is Critical".toLowerCase()
                )
                ?.customValue?.split("\n")
                .map((item, key) => {
                  return (
                    <span key={key}>
                      {dynamicMessages(item)?t(dynamicMessages(item)):item}
                      <br />
                    </span>
                  );
                })
            : this.props.config_values
                .find(
                  (ele) =>
                    ele.targetPageTitle.toLowerCase() ===
                      "Patient Responsibility Receipt".toLowerCase() &&
                    ele.element.toLowerCase() ===
                      "Patient Responsibility is Critical".toLowerCase()
                )
                ?.defaultValue?.split("\n")
                .map((item, key) => {
                  return (
                    <span key={key}>
                      {dynamicMessages(item)?t(dynamicMessages(item)):item}
                      <br />
                    </span>
                  );
                })
          : ``}
        {/* </strong>
        <ul>
          <li>
            {this.props.config_values &&
            this.props.config_values.find(
              (ele) =>
                ele.targetPageTitle.toLowerCase() ===
                  "Patient Responsibility Receipt".toLowerCase() &&
                ele.element.toLowerCase() ===
                  "Patient Responsibility is Critical".toLowerCase()
            )
              ? this.props.config_values.find(
                  (ele) =>
                    ele.targetPageTitle.toLowerCase() ===
                      "Patient Responsibility Receipt".toLowerCase() &&
                    ele.element.toLowerCase() ===
                      "Patient Responsibility is Critical".toLowerCase()
                )?.customValue
                ? this.props.config_values
                    .find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Patient Responsibility Receipt".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Patient Responsibility is Critical".toLowerCase()
                    )
                    ?.customValue?.split("\n")[1]
                : this.props.config_values
                    .find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Patient Responsibility Receipt".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Patient Responsibility is Critical".toLowerCase()
                    )
                    ?.defaultValue.split("\n")[1]
              : `You are only responsible for the Patient Responsibility shown on
                    your Plan’s Explanation of Benefits such as your deductible and/or
                    coinsurance.`}
          </li>
          <li>
            {this.props.config_values &&
            this.props.config_values.find(
              (ele) =>
                ele.targetPageTitle.toLowerCase() ===
                  "Patient Responsibility Receipt".toLowerCase() &&
                ele.element.toLowerCase() ===
                  "Patient Responsibility is Critical".toLowerCase()
            )
              ? this.props.config_values.find(
                  (ele) =>
                    ele.targetPageTitle.toLowerCase() ===
                      "Patient Responsibility Receipt".toLowerCase() &&
                    ele.element.toLowerCase() ===
                      "Patient Responsibility is Critical".toLowerCase()
                )?.customValue
                ? this.props.config_values
                    .find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Patient Responsibility Receipt".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Patient Responsibility is Critical".toLowerCase()
                    )
                    ?.customValue?.split("\n")[2]
                : this.props.config_values
                    .find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Patient Responsibility Receipt".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Patient Responsibility is Critical".toLowerCase()
                    )
                    ?.defaultValue.split("\n")[2]
              : `Ensure you upload receipts only for this DOS and this Provider.`}
          </li>
        </ul> */}
      </div>
    );

    let preview: any;
    if (
      this.props.patientsResponsibilityBills &&
      this.props.patientsResponsibilityBills.length > 0
    ) {
      preview = (
        <div className="uploadPreviews">
          {(this.props.patientsResponsibilityBills || []).map((url, index) => (
            <div className="uploadPreview" key={`file${index}`}>
              <div className="previewThumb">
                {console.log("url is ", url.name)}
                {url.name.includes("pdf") ? (
                  <Document file={url}>
                    <Page
                      pageNumber={1}
                      onClick={() => this.viewingBillsHandler(index)}
                    />
                  </Document>
                ) : (
                  <img
                    src={URL.createObjectURL(url)}
                    alt="..."
                    onClick={() => this.viewingBillsHandler(index)}
                  />
                )}
              </div>
              <span
                className="closeBtn"
                onClick={() => this.deleteHandler(index)}
              >
                <span>x</span>
              </span>
            </div>
          ))}
        </div>
      );
    }
    /**/
    let patientsResponsibility: any;
    if (this.state.explanationOfBenefits) {
      patientsResponsibility = (
        <ExplanationOfBenefits t={t}
          goBackHandler={this.explanationOfBenefitsBackHandler}
        />
      );
    } else {
      patientsResponsibility = (
        <Container fluid>
          {patientsResponsibilityBillsUpload}
          {viewBills}
          <div className="inner-banner">
            <div className="inner-banner-title">
              <h3>{t('balanceBilling.balanceBilling')}</h3>
              <Image
                src={dollar}
                alt="stock-image"
                className={classes.stockimage}
                data-test="stockIMG"
              />
            </div>
          </div>
          <div className="mainContainer">
            <div className="text-center">
              <h6 className="bill-heading">{t('uploadBill.newUpload')}</h6>
              <div className="step-circles">
                <ul>
                  <li className="active"></li>
                  <li className="active"></li>
                  <li className="active"></li>
                  <li className="select"></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <div className="bb-text">
                <strong>
                  {this.props.documentTypes.length > 0 &&
                    this.props.documentTypes.find((title) => title.order === 3)
                      ?.type}
                </strong>
                <p>
                  {this.props.config_values &&
                  this.props.config_values.find(
                    (ele) =>
                      ele.targetPageTitle.toLowerCase() ===
                        "Patient Responsibility Receipt".toLowerCase() &&
                      ele.element.toLowerCase() === "header".toLowerCase()
                  )
                    ? this.props.config_values.find(
                        (ele) =>
                          ele.targetPageTitle.toLowerCase() ===
                            "Patient Responsibility Receipt".toLowerCase() &&
                          ele.element.toLowerCase() === "header".toLowerCase()
                      )?.customValue
                      ? this.props.config_values
                          .find(
                            (ele) =>
                              ele.targetPageTitle.toLowerCase() ===
                                "Patient Responsibility Receipt".toLowerCase() &&
                              ele.element.toLowerCase() ===
                                "header".toLowerCase()
                          )
                          ?.customValue?.split("\n")[0]
                      : this.getConvertedQuestion()
                    : t('claims.balanceBillTxt')}
                    
                </p>
               
              </div>
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="customSwitches"
                  onChange={this.onChangeFavorite}
                />
                <span className="switchUnChecked">{t('uploadBill.yes')}</span>
                <label
                  className="custom-control-label"
                  htmlFor="customSwitches"
                ></label>
                <span className="switchChecked">{t('claims.no')}</span>
              </div>
            </div>

            {this.state.patientsResponsibilityUploaded &&
              patientsResponsibilityUploadedCount}
            {!this.state.patientsResponsibilityUploaded &&
              patientsResponsibilityBanner}
            {preview}

            <div className="text-center">
              {/* {!this.state.patientsResponsibilityUploaded && (
                <h5 className="text-grey m-b-25">
                  Upload Proof of Payment Receipts
                </h5>
              )} */}
              <Button
                className="btn-lg-border"
                onClick={this.uploadPatientsResponsibilityHandler}
                disabled={
                  this.state.patientsResponsibilityBillsAvailable ? false : true
                }
              >
                <span>
                  {this.state.patientsResponsibilityUploaded
                    ? t('submitBill.addMore')
                    : `${t('balanceBilling.uploadBtn')} ${
                        this.props.documentTypes.length > 0 &&
                        this.props.documentTypes.find(
                          (title) => title.order === 3
                        )?.type
                      }`}
                </span>
                <i>+</i>
              </Button>
            </div>

            <div className="flexButtons">
              <CustomButton
                label={t('uploadBill.back')}
                clicked={this.goBackHandler}
                style={nextBtnStyle}
                displayImg={false}
                image=""
                disabled={false}
              />
              <CustomButton
                label={t('uploadBill.next')}
                clicked={this.explanationOfBenefitsHandler}
                style={nextBtnStyle}
                displayImg={false}
                image=""
                disabled={
                  false
                  // this.state.patientsResponsibilityUploaded &&
                  // this.state.patientsResponsibilityBillsAvailable
                  //   ? false
                  //   : true
                }
              />
            </div>
          </div>
        </Container>
      );
    }
    return <Fragment>{patientsResponsibility}</Fragment>;
  }
}
const mapStateToProps = (state: any) => ({
  patientsResponsibilityBills: state.browseImages.patientsResponsibilityBills,
  documentTypes: state.fetchDocumentTypes.documentTypes,
  config_values: state.appConfig.config_values,
  balanceBillView: state.setBalanceBillViewState.balanceBillView,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onRemoveFiles: (patientsResponsibilityBills) =>
    dispatch(
      patientsResponsibilityActions.patientsResponsibilityBills(
        patientsResponsibilityBills
      )
    ),
  onSetBalanceBillViewState: (balanceBillView) =>
    dispatch(
      patientsResponsibilityActions.setBalanceBillViewState(balanceBillView)
    ),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PatientsResponsibility);
